<template>
  <div>
    <Modal v-model="editReceiverModal" :title="$t('key1006109')" class-name="commonModalStyles"
      :transfer="false" :mask-closable="false" width="1000" @on-visible-change="editReceiverModalChange">
      <Form ref="editReceiverForm" :model="editReceiverForm" :label-width="100" :rules="ruleValidate"
        @submit.native.prevent :disabled="optionsType === 'look'">
        <Row style="width: 80%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006110')" prop="buyerName">
              <Input clearable v-model.trim="editReceiverForm.buyerName"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006111')" prop="buyerAddress1">
              <Input clearable v-model.trim="editReceiverForm.buyerAddress1"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006112')" prop="buyerAddress2">
              <Input clearable v-model.trim="editReceiverForm.buyerAddress2"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001164')" prop="buyerCity">
              <Input clearable v-model.trim="editReceiverForm.buyerCity"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006113')" prop="buyerState">
              <Input clearable v-model.trim="editReceiverForm.buyerState"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005559')" prop="buyerPhone">
              <Input clearable v-model.trim="editReceiverForm.buyerPhone"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001174')" prop="buyerMobile">
              <Input clearable v-model.trim="editReceiverForm.buyerMobile"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001170')" prop="">
              <Input clearable v-model.trim="editReceiverForm.buyerPostalCode"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002677')" prop="buyerCountryCode">
              <Select v-model="editReceiverForm.buyerCountryCode" filterable transfer>
                <Option v-for="(item, index) in countrysData" :key="index" :label="item.cnName" :value="item.twoCode">{{ item.cnName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <!--当前所选目的国家需要录入IOSS相关信息-->
          <template v-if="destinationCountryTalg">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <p class="ml36 mb10">{{ $t('key1006114') }}</p>
              <Form-item prop="iossType" :label-width="35">
                <RadioGroup v-model="editReceiverForm.iossType" @on-change="selectChange">
                  <Radio style="margin-right: 30px;" v-for="item in iossTypeList" :label="item.value" :key="item.value">{{ item.name }}</Radio>
                </RadioGroup>
              </Form-item>
            </Col>
            <!--使用已有IOSS-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="editReceiverForm.iossType === 1">
              <Form-item :label="$t('key1005999')" prop="ymsIossId">
                <div class="flex align-items-center">
                  <Select v-model="editReceiverForm.ymsIossId" filterable transfer :placeholder="$t('key1000101')"
                    style="width: 250px;" @on-open-change="openIossChange">
                    <Option v-for="item in iossList" :value="item.code" :label="item.iossName">
                      <span v-html="item.title"></span>
                    </Option>
                  </Select>
                  <span class="ml5 cursor distributorThemeColor text-decoration" @click="goIossConfig">{{ $t('key1006002') }}</span>
                </div>
              </Form-item>
            </Col>
            <!--物流代缴-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="editReceiverForm.iossType === 2 && !iossLogisticCostTalg">
              <div class="flex flex-direction mt15 mb10 ml36">
                <p class="mb7">{{ $t('key1006000') + configCharacters() + $t('key1006001') }}</p>
                <p class="mb7">{{ $t('key1001579') + providerName }}</p>
                <p class="flex align-items-center">
                  <span>{{ $t('key1006003') }}</span>
                  <span class="distributorThemeColor ml3">{{ iossLogisticCost + ' ' + currencyState }}</span>
                </p>
              </div>
            </Col>
            <!--手动录入-->
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="editReceiverForm.iossType === 3">
              <Form-item :label="$t('key1005521')" prop="iossNo">
                <Input clearable v-model.trim="editReceiverForm.iossNo" style="width: 250px;"/>
              </Form-item>
            </Col>
          </template>
          <!--当前所选目的国家需要配置订单商品合规信息-->
          <template v-if="isShowComplianceInfoTalg && orderComplianceLabelVerificationTalg">
            <h2 class="font-size-14 color-333 mt20 mb12">{{ $t('key1006115') }}</h2>
            <div class="relatedComplianceInfo_box" v-for="ele in relatedComplianceInfoData">
              <div class="flex width_370 pr20">
                <div class="img_box">
                  <img :src="ele.pictureUrl" alt="">
                </div>
                <div class="ml12" style="flex: 1;">
                  <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
                  <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                  <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                  <p class="distributorThemeColor">{{ ele.specifications }}</p>
                </div>
              </div>
              <div style="flex:1">
                <!--责任人-->
                <div class="flex align-items-center mb15" v-for="item in responsibleAreaList.filter(j => j.zoneCode === receivingAddressZoneCode)">
                  <span class="red-dot">{{ item.name + $t('key1005986') }}</span>
                  <Select v-model="ele.selectYmsCompliancePersonId" filterable style="width: 280px;">
                    <Option v-for="k in personInChargeList.filter(talg => talg.zoneCode === receivingAddressZoneCode)" :value="k.ymsCompliancePersonId">
                      {{ k.name }}
                    </Option>
                  </Select>
                </div>
                <!--制造商-->
                <div class="flex align-items-center">
                  <span class="red-dot">{{ manufacturerName }}</span>
                  <Select v-model="ele.selectYmsManufacturerInfoId" filterable style="width: 280px;">
                    <Option v-for="k in manufacturerData" :value="k.ymsManufacturerInfoId">{{ k.name }}</Option>
                  </Select>
                </div>
              </div>
            </div>
          </template>
          <p class="ml36 crimsonRedColor">{{ $t('key1006116') }}</p>
        </Row>
      </Form>
      <template #footer>
        <Button @click="editReceiverModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="editReceiverBtn" :loading="editReceiverLoading" v-if="optionsType === 'edit'"
          :disabled="editReceiverForm.iossType === 2 && iossLogisticCostTalg">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!--物流单作废费收取提示弹窗-->
    <collectionOfScrapFeesForLogisticsModal
      ref="collectionOfScrapFeesForLogistics"
      @updateSubmit="updateSubmit"
    ></collectionOfScrapFeesForLogisticsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import collectionOfScrapFeesForLogisticsModal from "@/components/common/collectionOfScrapFeesForLogisticsModal.vue";
import {
  amountHandel, getAllCountrysData, getAllManufacturerData, getAllPersonInChargeData, commonLocalStorage,
  getCountryZoneData, getDataSetBatchList, getEnumList, getIossTaxRateData, getYunLogisticsAll
} from "@/utils/common";

export default {
  name: 'editReceiverModal',
  mixins: [Mixin],
  props: {
    receiverType: { // 类型 默认是平台订单--->收货人信息
      type: String,
      default: 'platformOrder'
    }
  },
  data() {
    let v = this;
    return {
      editReceiverModal: false,
      editReceiverForm: {
        buyerAccountId: '',
        buyerAddress1: '',
        buyerAddress2: '',
        buyerCity: '',
        buyerCountryCode: '',
        buyerEmail: '',
        buyerMobile: '',
        buyerName: '',
        buyerPassportCode: '',
        buyerPhone: '',
        buyerPostalCode: '',
        buyerState: '',
        ymsPlatformOrderId: null,
        ymsPackageId: null,
        iossType: 1,
        ymsIossId: null,
        iossNo: null,
      },
      iossLogisticCost: 0,
      iossLogisticCostTalg: true,
      iossList: [],
      ruleValidate: {
        ymsIossId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005439'), trigger: 'change'},
        ],
        iossNo: [
          {required: true, validator: v.validateIoss(), trigger: 'blur'}
        ],
      },
      iossTaxRateList: [],
      editReceiverInfo: {},
      providerName: '',
      editReceiverLoading: false,
      optionsType: null,
      ymsPlatformOrderShippingId: null,
      responsibleAreaList: [],
      relatedComplianceInfoData: [],
      personInChargeList: [],
      manufacturerData: [],
      isShowComplianceInfoTalg: false, // 是否展示合规信息
      countrysData: [],
      enumData: []
    };
  },
  computed: {
    // 是否在IOSS目的国范围中
    destinationCountryTalg() {
      let talg = this.iossTaxRateList.some((item) => {
        return item.countryCode === this.editReceiverForm.buyerCountryCode;
      });
      return talg;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 判断收货地址是否是欧盟、土耳其
    receivingAddressZoneCode() {
      let zoneCode = null;
      let countryCode = this.editReceiverForm.buyerCountryCode;
      if (countryCode) {
        this.responsibleAreaList.map((item) => {
          if (item.countries.includes(countryCode)) {
            zoneCode = item.zoneCode;
          }
        })
      }
      return zoneCode;
    },
    manufacturerName() {
      let name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000282');
      let manufacturerName = '';
      this.responsibleAreaList.map((item) => {
        if (item.zoneCode === this.receivingAddressZoneCode) {
          manufacturerName = item.name;
        }
      })
      return manufacturerName + name;
    },
    iossTypeList() {
      const ENUM_KEY = 'YmsPlatformOrderPackageRelatedIossTypeDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  methods: {
    // 初始化数据
    initEditReceiverData(data, type) {
      let v = this;
      v.optionsType = type;
      v.iossTaxRateList = [];
      v.ymsPlatformOrderShippingId = data.ymsPlatformOrderShippingId || null;
      (async () => {
        let enumKeyList = ['YmsPlatformOrderPackageRelatedIossTypeDistributorEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getIossTaxRateData('distributor').then((newData) => {
          v.iossTaxRateList = newData;
        });
        await getAllPersonInChargeData().then((data) => {
          v.personInChargeList = data;
        });
        await getAllManufacturerData().then((data) => {
          v.manufacturerData = data;
        });
        await getCountryZoneData().then((data) => {
          v.responsibleAreaList = data;
        });
        await getAllCountrysData().then((data) => {
          v.countrysData = data;
        });
        await v.getConsigneeInfo(data);
      })();
    },
    // 获取收货人信息
    getConsigneeInfo(data) {
      let v = this;
      v.editReceiverInfo = data;
      for (let key in v.editReceiverForm) {
        v.editReceiverForm[key] = data.ymsPackageInfo[key] || '';
      }
      v.editReceiverForm.ymsPlatformOrderId = data.ymsPlatformOrderId;
      v.editReceiverForm.iossType = data.iossType ? data.iossType : 1;
      if (v.editReceiverForm.iossType === 1) {
        v.editReceiverForm.iossNo = null;
        v.editReceiverForm.ymsIossId = data.iossNo;
      }
      if (v.editReceiverForm.iossType === 2) {
        v.iossLogisticCost = data.iossLogisticCost;
        v.iossLogisticCostTalg = false;
      }
      if (v.editReceiverForm.iossType === 3) {
        v.editReceiverForm.ymsIossId = null;
        v.editReceiverForm.iossNo = data.iossNo;
      }
      // 获取物流商
      v.providerName = '';
      let providerName = '';
      if (data.ymsPackageInfo) {
        getYunLogisticsAll().then((ymsLogisticsData) => {
          let ymsLogisServiceId = data.ymsPackageInfo.ymsLogisServiceId;
          if (ymsLogisServiceId) {
            if (ymsLogisticsData.length > 0) {
              ymsLogisticsData.map((item) => {
                if (item.ymsLogisServiceId === ymsLogisServiceId) {
                  providerName = item.name;
                }
              })
            }
          }
          v.providerName = providerName;
        });
      }

      // 是否展示合规信息
      let countryCode = null;
      let orderShippingWarehouseAddress = data.ymsPackageInfo?.orderShippingWarehouseAddress || [];
      if (orderShippingWarehouseAddress.length > 0) {
        orderShippingWarehouseAddress.map((k) => {
          if (k.addressType === 'sender') {
            countryCode = k.countryCode;
          }
        })
      }
      if (v.receivingAddressZoneCode) {
        v.responsibleAreaList.map((ele) => {
          if (ele.zoneCode === v.receivingAddressZoneCode) {
            if (!ele.countries.includes(countryCode)) {
              v.isShowComplianceInfoTalg = true;
              v.getComplianceData(data.goodsList)
            }
          }
        })
      } else {
        v.isShowComplianceInfoTalg = false;
      }
      v.editReceiverModal = true;
    },
    // 获取合规信息的数据
    getComplianceData(productGoodsList) {
      this.relatedComplianceInfoData = [];
      if (productGoodsList.length > 0) {
        productGoodsList.forEach(item => {
          const spuInfo = item._productInfo && item._productInfo._spuInfo;
          const compliancePersonProductList = Array.isArray(spuInfo?.compliancePersonProductList)
            ? spuInfo.compliancePersonProductList : [];
          const ymsManufacturerInfoProductList = Array.isArray(spuInfo?.ymsManufacturerInfoProductList)
            ? spuInfo.ymsManufacturerInfoProductList : [];
          // 负责人
          let ymsProductId = item.ymsProductId || spuInfo.ymsProductId;
          const compliance = compliancePersonProductList.find(
            ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
          item.selectYmsCompliancePersonId = compliance
            ? compliance.ymsCompliancePersonId : item.selectYmsCompliancePersonId || null;

          // 制造商
          const manufacturer = ymsManufacturerInfoProductList.find(
            ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
          item.selectYmsManufacturerInfoId = manufacturer
            ? manufacturer.ymsManufacturerInfoId : item.selectYmsManufacturerInfoId || null;
        });
        this.relatedComplianceInfoData = productGoodsList;
      }
    },
    // 获取启用的IOSS
    openIossChange(val) {
      let v = this;
      if (val) {
        v.iossList = [];
        v.axios.get(api.get_ymsIoss_queryEnable).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                item.title = item.code + '<br/>' + item.name;
                item.iossName = item.code + ' / ' + item.name;
              })
            }
            v.iossList = data;
          }
        });
      }
    },

    // 修改收货人信息的保存按钮
    editReceiverBtn() {
      let obj = {
        totalPrice: this.editReceiverInfo.ymsPackageInfo.totalPrice,
        trackingNumberTime: this.editReceiverInfo.ymsPackageInfo.trackingNumberTime,
        ymsPackageId: this.editReceiverInfo.ymsPackageInfo.ymsPackageId,
      }
      this.$refs['collectionOfScrapFeesForLogistics'].initCollectionOfScrapFeesForLogisticsData(obj).then((value) => {
        if (!value) {
          this.saveData();
        }
      });
    },
    // 处理保存数据
    saveData() {
      let v = this;
      let {ymsIossId, ymsPlatformOrderId, ...obj} = v.editReceiverForm;
      let query = Object.assign({}, obj);
      if (ymsPlatformOrderId) {
        query.ymsPlatformOrderId = ymsPlatformOrderId;
      }
      if (v.editReceiverInfo.ymsPackageInfo.hasOwnProperty('isHand')) {
        query.isHand = v.editReceiverInfo.ymsPackageInfo.isHand;
      }
      if (v.destinationCountryTalg) {
        query.iossNo = v.editReceiverForm.iossType === 1 ? ymsIossId : v.editReceiverForm.iossType === 3 ? v.editReceiverForm.iossNo : null;
        query.iossLogisticCost = v.editReceiverForm.iossType === 2 ? v.iossLogisticCost : null;
      } else {
        query.iossType = null;
        query.iossNo = null;
        query.iossLogisticCost = null;
      }
      if (v.receiverType === 'platformOrder') {
        query.ymsPlatformOrderShippingId = v.ymsPlatformOrderShippingId;
      }
      let validateField = [];
      if (v.editReceiverForm.iossType === 3) {
        validateField = ['iossNo'];
      } else if (v.editReceiverForm.iossType === 1 && ymsIossId) {
        validateField = ['ymsIossId'];
      }
      let insertYmsManufacturerInfoProductBoList = [];
      let insertYmsCompliancePersonProductBoList = [];
      if (v.isShowComplianceInfoTalg && v.orderComplianceLabelVerificationTalg) {
        if (v.relatedComplianceInfoData.length > 0) {
          v.relatedComplianceInfoData.forEach(item => {
            if (item.selectYmsCompliancePersonId) {
              insertYmsCompliancePersonProductBoList.push({
                ymsCompliancePersonId: item.selectYmsCompliancePersonId,
                ymsProductId: item.ymsProductId,
                ymsDistributorMerchantId: v.userInfo.merchantId,
                zoneCode: v.receivingAddressZoneCode
              });
            }
            if (item.selectYmsManufacturerInfoId) {
              insertYmsManufacturerInfoProductBoList.push({
                ymsManufacturerInfoId: item.selectYmsManufacturerInfoId,
                ymsProductId: item.ymsProductId,
                ymsDistributorMerchantId: v.userInfo.merchantId,
                zoneCode: v.receivingAddressZoneCode
              });
            }
          });
        }
      } else {
        query.insertYmsCompliancePersonProductBoList = [];
        query.insertYmsManufacturerInfoProductBoList = [];
      }
      query.insertYmsCompliancePersonProductBoList = insertYmsCompliancePersonProductBoList;
      query.insertYmsManufacturerInfoProductBoList = insertYmsManufacturerInfoProductBoList;
      if (validateField.length > 0) {
        Promise.all(validateField.map(field => {
          const promise = new Promise(function (resolve, reject) {
            v.$refs['editReceiverForm'].validateField(field, (error) => {
              resolve(error)
            })
          })
          return promise
        })).then((data) => {
          if (data.every(i => !i)) {
            verifyAddressFun(query);
          }
        });
      } else {
        verifyAddressFun(query);
      }

      // 校验变更地址是否可达
      function verifyAddressFun(query) {
        v.editReceiverLoading = true;
        v.axios.put(api.put_ymsDistributorPackageInfo_validateLogis, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006104')}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              handleData(query)
            } else {
              v.$Modal.confirm({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006105'),
                content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006106'),
                okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006107'),
                cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                onOk: () => {
                  v.editReceiverLoading = true;
                  handleData(query)
                },
                onCancel: () => {
                  v.editReceiverLoading = false;
                }
              });
            }
          } else {
            v.editReceiverLoading = false;
          }
        }).catch(() => {
          v.editReceiverLoading = false;
        })
      }

      function handleData(query) {
        v.axios.put(api.put_ymsDistributorPackageInfo_updateOrderBuyerInfo, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006108')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
            v.editReceiverModal = false;
            v.$emit('updateData', true);
            v.editReceiverLoading = false;
          } else {
            v.editReceiverLoading = false;
          }
        }).catch(() => {
          v.editReceiverLoading = false;
        });
      }
    },
    // 回调方法
    updateSubmit() {
      this.saveData();
    },
    // 监听弹窗
    editReceiverModalChange(value) {
      if (!value) {
        this.relatedComplianceInfoData = [];
        this.isShowComplianceInfoTalg = false;
        this.editReceiverLoading = false;
        this.iossLogisticCostTalg = true;
        this.iossLogisticCost = null;
        this.$refs['editReceiverForm'].resetFields();
      }
    },

    // 前往配置
    goIossConfig() {
      localStorage.setItem('openIossConfig', JSON.stringify(true));
      setTimeout(() => {
        const {href} = this.$router.resolve({
          path: '/iossManageList'
        });
        window.open(href, '_blank');
      }, 400);
    },
    // 校验IOSS编号
    validateIoss() {
      let v = this;
      let isIoss = v.$regular.isIoss;
      return function (rule, value, callback) {
        if (!value) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005518')));
        } else if (!isIoss.test(value)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005519')));
        }
        callback();
      };
    },
    // 切换类型
    selectChange(value) {
      let v = this;
      v.iossLogisticCost = 0;
      v.iossLogisticCostTalg = true;
      setTimeout(() => {
        if (value === 2) {
          // 平台订单-->收货人信息
          if (v.receiverType === 'platformOrder') {
            let query = {
              ymsPlatformOrderId: v.editReceiverInfo.ymsPlatformOrderId,
              ymsPlatformOrderPackageRelatedId: v.editReceiverInfo.ymsPlatformOrderPackageRelatedId,
              buyerCountryCode: v.editReceiverForm.buyerCountryCode
            }
            v.axios.post(api.post_ymsPlatformOrder_getIOSSLogisticCost, query, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || 0;
                if (data) {
                  v.iossLogisticCost = amountHandel(data);
                }
                v.iossLogisticCostTalg = false;
              }
            });
          }
          // YMS订单-->收货人信息
          else {
            let {
              buyerAddress1, buyerCity, buyerCountryCode, buyerEmail, buyerMobile, buyerName,
              buyerAccountId, buyerPhone, buyerPostalCode, buyerState, ymsLogisServiceId, ymsPackageGoods
            } = v.editReceiverInfo.ymsPackageInfo;
            let query = {
              merchantId: v.userInfo.merchantId,
              ymsPackageInfos: [
                {
                  buyerAddress1,
                  buyerCity,
                  buyerCountryCode,
                  buyerEmail,
                  buyerMobile,
                  buyerName,
                  buyerAccountId,
                  buyerPhone,
                  buyerPostalCode,
                  buyerState,
                  ymsLogisServiceId,
                  ymsPackageGoods: []
                }
              ]
            };
            if (ymsPackageGoods.length > 0) {
              query.ymsPackageInfos[0].ymsPackageGoods = ymsPackageGoods.map((item) => {
                return {
                  quantity: item.quantity,
                  ymsSku: item.ymsSku
                }
              });
            }
            v.axios.post(api.post_ymsPlatformOrder_getIossCostToOrder, query, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || 0;
                if (data) {
                  v.iossLogisticCost = amountHandel(data);
                }
                v.iossLogisticCostTalg = false;
              }
            });
          }
        }
      }, 400);
    },
  },
  watch: {
    'editReceiverForm.iossType': {
      handler(value) {
        let fieldlist = this.$refs['editReceiverForm'].fields;
        let keyList = [];
        if (value === 1) {
          keyList = ['ymsIossId'];
        } else if (value === 3) {
          keyList = ['iossNo'];
        }
        fieldlist.map((item, index) => {
          if (keyList.includes(item.prop)) {
            item.resetField();
            this.$forceUpdate();
          }
        });
      },
      deep: true
    }
  },
  components: {
    collectionOfScrapFeesForLogisticsModal,
  }
};
</script>

<style lang="less" scoped>
/deep/ .commonModalStyles {
  .relatedComplianceInfo_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 16px;
    padding-bottom: 16px;
    max-height: 400px;
    overflow-y: auto;

    .img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #E2E2E2;
    }

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>
